
import { Component, Prop, toNative, Vue, Watch } from 'vue-facing-decorator';
import { ParticipantGroups } from '@/entities/ParticipantGroups';
import { StoreHelper } from '@/store/StoreHelper';
import { AppRequestInfo } from '@/entities/AppRequestInfo';
import { Store, Root, FetchData } from '@/main';
import InputControlCheckBox from './InputControlCheckBox.vue';
import { InputControlCheckBoxViewModel } from '@/entities/InputControlCheckBoxViewModel';
import SubModuleTypeEnum from '@/enums/SubModuleTypeEnum';
@Component({
  components: {
    InputControlCheckBox,
  },
})
class ListOfParticipantGroups extends Vue {
  @Prop() private participantGroups?: ParticipantGroups[];
  @Prop() private subHeading?: string;
  @Prop() private displayGroupInfoInApp?: boolean;
  @Prop() private subModuleType?: number;
  private loadingImage: string = require('@/assets/Images/loading.png');
  private showInformation = false;
  private showNotAvailableInformation = false;
  private isGroupsAvailable = false;
  private hasSelectedGroups = false;
  private selectedParticipantGroups: ParticipantGroups[] = [];
  private isEnabledSelectedGroupOption = false;
  private isEnableParticipantList = false;
  private localLinkedProgramLoading = false;
  private Groups: number[] = [];
  private localParticipantGroups: ParticipantGroups[] = [];
  private isGroupVisibilityTooltipVisible = false;
  private localDisplayGroupInfoInApp = false;
  private inputControlData: InputControlCheckBoxViewModel[] | undefined = undefined;
  private selectedParticipantCount = 0;
  private selectedParticipantGroupIds: number[] = [];
  public get selectedSubModuleType(): typeof SubModuleTypeEnum {
    return SubModuleTypeEnum;
  }
  private mounted() {
    // assign participantGroups in local variable
    if (this.participantGroups !== null) {
      this.localParticipantGroups = this.participantGroups!;
      this.SetDataForInputControl();
    }
    if(this.displayGroupInfoInApp !== null && this.displayGroupInfoInApp !== undefined) {
      this.localDisplayGroupInfoInApp = this.displayGroupInfoInApp;
    }
    // loader off from custom category end
    Root.on('customCategoryDetailLoading', (loading: boolean) => {
      this.localLinkedProgramLoading = loading ;
    });
    // loader off from prgram end
    Root.on('programDetailLoading', (loading: boolean) => {
      this.localLinkedProgramLoading = loading ;
    });
    // Check Enable participant on or off from setting
    const storeHelper: StoreHelper = new StoreHelper(Store);
    const reqInfo: AppRequestInfo = storeHelper.GetRequestInfoFromStore();
    this.isEnableParticipantList = reqInfo.EnableParticipantList;
    const $this = this;
    Root.on('selected-participant-group-is', ( ParticipantGroupIds: number[]) => {
      // set selected groups
      $this.selectedParticipantGroups = [];
      $this.selectedParticipantGroupIds = ParticipantGroupIds;
      $this.Groups = ParticipantGroupIds ;
      $this.GetGroupsData();
      if ($this.Groups !== null && $this.Groups !== undefined && $this.Groups.length > 0) {

        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let i = 0; i < $this.Groups.length; i++) {
          $this.selectedParticipantGroups.push($this.participantGroups!.find((record) => record.Id === $this.Groups[i])!);
        }
      }
      Root.emit('sendListOfParticipantGroupsInLocalItem', $this.selectedParticipantGroups);
      if(this.subModuleType === this.selectedSubModuleType.Chat) {
        this.GetParticipantsInfoByGroupId();
      }
    });
    if (this.participantGroups!.length > 0) {
      this.isEnabledSelectedGroupOption = true;
    }
  }
  private ShowGroupVisibilityCheckBox() {
    return this.displayGroupInfoInApp !== null && this.displayGroupInfoInApp !== undefined && this.hasSelectedGroups;
  }
  private ShowHideGroupVisibilityTooltip(val: boolean) {
    this.isGroupVisibilityTooltipVisible = val;
  }
  private SetGroupVisibilityCheckboxValue() {
    if(this.selectedParticipantGroups.length > 0) {
      this.localDisplayGroupInfoInApp = (this.$refs.chkGroupVisibility as HTMLInputElement).checked;
      this.$emit('set-group-visibility-value', this.localDisplayGroupInfoInApp);
    }
  }
  private setSelectedParticipantGroups(Groups: number[]) {
    // func use for set selected participant groups
    this.selectedParticipantGroups = [];
    if (this.Groups !== null && this.Groups !== undefined && this.Groups.length > 0) {
      // eslint-disable-next-line @typescript-eslint/prefer-for-of
      for (let i = 0; i < Groups.length; i++) {
        this.selectedParticipantGroups.push(this.participantGroups!.find((record) => record.Id === Groups[i])!);
      }
    }
    if (this.participantGroups!.length > 0) {
      this.isGroupsAvailable = true;
      this.isEnabledSelectedGroupOption = true;
    }
  }

  private getInformationString(val: boolean, type: string) {
    // for toolip information
    if (type === 'Not Available') {
      this.showNotAvailableInformation = val;
    } else {
      this.showInformation = val;
    }
  }

  private selectedOptionChange() {
    // func use when we change checkBox value
    // emit checkbox values acc.  to checkbox
    this.isGroupsAvailable = false;
    if (this.hasSelectedGroups === false) {
      // when user select everyone option empty the array
      this.selectedParticipantGroups = [];
      Root.emit('sendListOfParticipantGroupsInLocalItem', this.selectedParticipantGroups);
      this.$emit('sendListOfParticipantGroupsIneditpane', this.selectedParticipantGroups);

      // if everyone is selected then uncheck Display group information in app
      this.localDisplayGroupInfoInApp = false;
      this.$emit('set-group-visibility-value', this.localDisplayGroupInfoInApp);
      this.SetDataForInputControl();
    } else if (this.hasSelectedGroups === true) {
      this.isGroupsAvailable = true;
      Root.emit('sendListOfParticipantGroupsInLocalItem', this.selectedParticipantGroups);
      this.$emit('sendListOfParticipantGroupsIneditpane', this.selectedParticipantGroups);
    }
  }

  private GetGroupsData() {
    // show hide checkbox acc to data
    this.isGroupsAvailable = false;
    this.hasSelectedGroups = false;
    if (this.Groups !== null && this.Groups !== undefined && this.Groups.length > 0 && this.isEnableParticipantList  ) {
      this.isGroupsAvailable = true;
      this.hasSelectedGroups = true;
    }
  }
  private isDisableCheckBox() {
    if (this.isEnabledSelectedGroupOption && this.isEnableParticipantList) {
      return true;
    } else {
      return false;
    }
  }
  private SetDataForInputControl() {
    this.inputControlData = [];
    this.localParticipantGroups.forEach((item) => {
      const chkBoxData = InputControlCheckBoxViewModel.createEmpty();
      chkBoxData.Id = item.Id;
      chkBoxData.Label = this.GetParticipantCountInGroup(item.Name, item.ParticipantCounts.toString());
      chkBoxData.IsChecked = !!this.selectedParticipantGroups ? this.selectedParticipantGroups.some((val) => val.Id === item.Id) : false;
      this.inputControlData!.push(chkBoxData);
    });
  }
  // Use to set label for the input control
  private GetParticipantCountInGroup(name: string, count: string) {
    return this.$t('Dialogue.Filter.ParticipantGroupCount',{name, count}).toString();
  }
  // Use to add newwly added group from input control
  private SetSelectedParticipantGroupIds(data: InputControlCheckBoxViewModel[]) {
    this.selectedParticipantGroups = [];
    this.selectedParticipantGroupIds = [];
    data.forEach((item) => {
      if (item.IsChecked) {
        const groupDetails: ParticipantGroups = ParticipantGroups.createEmpty();
        const selectedGroup = this.localParticipantGroups.find((val)=> val.Id === item.Id);
        groupDetails.Id = item.Id;
        groupDetails.Name = selectedGroup!.Name;
        groupDetails.ParticipantCounts = selectedGroup!.ParticipantCounts;
        this.selectedParticipantGroups.push(groupDetails);
        this.selectedParticipantGroupIds.push(item.Id);
      }
    });
    // if selectedParticipantGroups is equal to  0 then uncheck Display group information in app
    if (this.selectedParticipantGroups.length === 0) {
      this.localDisplayGroupInfoInApp = false;
      this.$emit('set-group-visibility-value', this.localDisplayGroupInfoInApp);
    }
    this.selectedOptionChange();
    if(this.subModuleType === this.selectedSubModuleType.Chat) {
      this.GetParticipantsInfoByGroupId();
    }
  }
  private GetParticipantsInfoByGroupId() {
    // get Participant count for the selected Participant group / Segment choice / Interest
    FetchData('/ApplicationInstance/GetParticipantsInfoByGroupId', JSON.stringify({
      groupIds: this.selectedParticipantGroupIds,
    }))
      .then((response) => {
        const participantcount = response.userFilters;
        this.selectedParticipantCount = participantcount;
      })
      .catch(() => {
        // Log err
      });
  }
  @Watch('Groups')
  private onParticipantGroupsChange(val: number[]) {
    // switching between programs and set data acc. to new selected program data
    this.selectedParticipantGroups = [];
    this.GetGroupsData();
    if (val !== undefined && val !== null && val.length > 0) {
      this.setSelectedParticipantGroups(val);
    }
    this.SetDataForInputControl();
  }
  @Watch('displayGroupInfoInApp')
  private CheckChangeInDisplayGroupInfoInApp(val: boolean) {
    this.localDisplayGroupInfoInApp = val;
  }
}
export default toNative(ListOfParticipantGroups);
